declare global {
  interface Window {
    __IS_PRERENDERED__?: boolean;
  }
}

// is prerendering by Puppeteer
export const isPrerendering =
  typeof navigator !== 'undefined' && navigator.userAgent === 'prerender';

// was static HTML prerendered before React
export const wasPrerendered =
  typeof window !== 'undefined' && window.__IS_PRERENDERED__;
